import React from "react";
import { DesktopFormatBubble, DesktopFormatBubbleSettings } from "./DesktopFormatBubble";
import { MobileFormatBubble, MobileFormatBubbleSettings } from "./MobileFormatBubble";
import { SlideAction } from "./SlideAction";

export type FormatBubbleSettings = { mobile: MobileFormatBubbleSettings } | { desktop: DesktopFormatBubbleSettings };

interface Props {
	settings: FormatBubbleSettings;
	onClickSlidePrompt: (slideAction: SlideAction) => void;
	excecuteEditorAction: (action: string, value?: string) => void;
}

export function FormatBubble(props: Props) {
	const { settings } = props;

	if ("mobile" in settings) {
		return <MobileFormatBubble settings={settings.mobile} onClickSlidePrompt={props.onClickSlidePrompt} />;
	}
	return (
		<DesktopFormatBubble
			settings={settings.desktop}
			onClickSlidePrompt={props.onClickSlidePrompt}
			excecuteEditorAction={props.excecuteEditorAction}
		/>
	);
}

export default FormatBubble;
